import { UserType, UserTypes } from 'src/Libs/user/types'
import { BottomBarPosition } from '../consts'

const isInstallationConfigurationPath = (pathname: string): boolean =>
  pathname.startsWith('/installation/') && pathname.split('/').includes('configuration')

export const getUserActivePage = (pathname: string, eMobilityActionPath: string): BottomBarPosition => {
  if (pathname.startsWith('/dashboard/overview')) return BottomBarPosition.ZERO
  if (isInstallationConfigurationPath(pathname)) return BottomBarPosition.THREE
  if (pathStartsWith(pathname, '/installation')) return BottomBarPosition.ONE
  if (pathname.startsWith(eMobilityActionPath)) return BottomBarPosition.TWO
  else return BottomBarPosition.THREE
}

export const getInstallerPartnerActivePage = (pathname: string, eMobilityActionPath: string): BottomBarPosition => {
  if (pathname.startsWith('/installer-dashboard')) return BottomBarPosition.ZERO
  if (pathname.startsWith('/dashboard/overview')) return BottomBarPosition.ONE
  if (isInstallationConfigurationPath(pathname)) return BottomBarPosition.FOUR
  if (pathStartsWith(pathname, '/installation')) return BottomBarPosition.TWO
  if (pathname.startsWith(eMobilityActionPath)) return BottomBarPosition.THREE
  else return BottomBarPosition.FOUR
}

export const getServiceActivePage = (pathname: string, eMobilityActionPath: string): BottomBarPosition => {
  if (pathname.startsWith('/overview')) return BottomBarPosition.ZERO
  if (pathname.startsWith('/dashboard/overview/')) return BottomBarPosition.ONE
  if (isInstallationConfigurationPath(pathname)) return BottomBarPosition.FOUR
  if (pathStartsWith(pathname, '/installation')) return BottomBarPosition.TWO
  if (pathname.startsWith(eMobilityActionPath)) return BottomBarPosition.THREE
  else return BottomBarPosition.FOUR
}

export const getDefaultActivePage = (pathname: string): BottomBarPosition => {
  if (isInstallationConfigurationPath(pathname)) return BottomBarPosition.THREE
  if (pathname.startsWith('/overview') || pathname.startsWith('/installer-dashboard') || pathname.startsWith('/installation/new-installation'))
    return BottomBarPosition.ZERO
  if (pathname.startsWith('/dashboard/overview')) return BottomBarPosition.ONE
  if (pathStartsWith(pathname, '/installation')) return BottomBarPosition.TWO
  else return BottomBarPosition.THREE
}

export const pathStartsWith = (path: string, start: string): boolean => {
  return path.startsWith(start) && !path.includes(`${start}-`)
}

export const getActivePage = (userType: UserType, pathname: string, isVehicleConnected: boolean): BottomBarPosition => {
  const eMobilityActionPath = isVehicleConnected ? '/vehicle-integration' : '/e-mobility'

  switch (userType) {
    case UserTypes.owner: {
      return getUserActivePage(pathname, eMobilityActionPath)
    }
    case UserTypes.installerPartner:
      return getInstallerPartnerActivePage(pathname, eMobilityActionPath)
    case UserTypes.installationOverview:
    case UserTypes.service:
      return getServiceActivePage(pathname, eMobilityActionPath)
    default:
      return getDefaultActivePage(pathname)
  }
}
